import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createScreenLayoutItem = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createScreenLayoutItem($type: String!, $label: String!, $bucketGroupId: Int, $teamId: Int, $position: Int!) {
            createScreenLayoutItem(type: $type, label: $label, bucketGroupId: $bucketGroupId, teamId: $teamId, position: $position) {
            id
            label
            type
            bucketGroupId
            teamId
            position
            createdAt
            error
            message
          }
        }
      `),
      variables: { type: data.type, label: data.label, bucketGroupId: data.bucketGroupId, position: data.position, teamId: data.teamId }
    })
  return response.data.createScreenLayoutItem
}

export const updateScreenLayoutItem = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
          mutation updateScreenLayoutItem( $id: Int!, $position: Int!) {
            updateScreenLayoutItem(id: $id, position: $position) { error message }
          }
        `),
      variables: { id: data.id, position: data.position }
    })
  return response.data.updateScreenLayoutItem
}

export const deleteScreenLayoutItem = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation deleteScreenLayoutItem($id: Int!) {
            deleteScreenLayoutItem(id: $id) { error message }
        }
      `),
      variables: { id: data.id }
    })
  return response.data.deleteScreenLayoutItem
}
